import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { UpdateInfoViewModel } from "./update-web-app.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Observable } from "rxjs";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";

@Component({
  selector: "app-update-web-app",
  templateUrl: "./update-web-app.component.html",
  styleUrls: ["./update-web-app.component.scss"],
})
export class UpdateWebAppComponent extends BaseFormComponent<any> {
  UpdateInfo: string[];
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private splashFormService: SplashFormService
  ) {
    super(selectorService, cd);
    this.setFormGroup();
  }
  async ngOnInit() {
    this.apiName = "";
    this.areaName = "";
    this.label = this.translate("ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.SoftwareUpdateInfo");
    super.ngOnInit();
    this.GetData();
  }

  async GetData() {
    this.columns = [];
    this.columns.push(<form_control>{});
    this.orignalColumns = this.columns;
    await this.httpCommonService
      .get("Home/GetUpdateInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (data: UpdateInfoViewModel) => {
        this.UpdateInfo = data.UpdateInfo;
        if (this.UpdateInfo == null) {
          this.sts.showDialog(
            this.translate("ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.NothingShow"),
            this.translate("ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.Warning"),
            DialogType.alert,
            () => {
              // this.closeDialog(true);
            }
          );
        }
      });
  }
  async save() {
    try {
      this.splashFormService.openDialog("", this.translate("ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.Saving"));
      this.sts.showDialog(
        this.translate("ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.SoftwareNotImplemented"),
        this.translate("ClientApp.Projects.FrameWorkShell.Header.UpdateWebApp.Warning"),
        DialogType.confirm,
        async () => {
          if(this.accountService.authService.currentBranch?.HasLocalService){
            const url = "http://" + this.accountService.authService.currentBranch.LocalServiceIp + "/UpdateSoftware";
           await this.httpCommonService
              .getCustom(url)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                async(data: any) => {
                },
                (err) => {
                  console.log(err);
                });
          }
          await this.httpCommonService
            .get("Home/UpdateSoftware")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              async (data) => {

                setTimeout(() => {
                  window.location.reload();
                  console.log();  
                }, 15000);
              },
              (error) => {
                console.log(error);
              }
            );
          this.splashFormService.closeLoading();
        },
        () => {
          this.selectorService.submitted$.next(this.submitted);
          this.splashFormService.closeLoading();
        });
    } catch {
      return;
    }
  }

  closeDialog(flag: boolean = false): void {
    if (flag && (this.isCanceling || this.isCloseable())) {
      if (this._id?.metadata?.id) {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      }
      this.close();
    }
    this.isClosing = false;
  }
}
